/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import "./Navigation.css";
import { Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

const Navigation = () => {
  return (
    <Navbar className="navigation-bar" expand="lg">
      <Container>
        <Navbar.Brand>
          <h3 className="logo">
            <span>M</span>ehedi
          </h3>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <div className="navigation-menu">
              <Link to="/home">Home</Link>
              <Link to="/about">About</Link>
              {/* <Link to="/blogs">Blogs</Link> */}
              <Link to="/projects">Projects</Link>
              <Link to="/contact">Contact</Link>
            </div>
            <div className="resume-div">
              <a
                target="_blank"
                href="https://drive.google.com/file/d/1KsR0LryLLUmPsnYDjtdznkUJQT6PENTA/view?usp=sharing"
              >
                <i className="fas fa-download"></i> Download Resume
              </a>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
